<template>
    <div style="width: 80%;margin-top: 5%;margin-left: 10%">
        <el-steps :active="active"
                  finish-status="success"
                  align-center>
            <el-step title="验证邀请码">
            </el-step>
            <el-step title="填写部门信息"></el-step>
            <el-step title="填写员工信息"></el-step>
            <el-step title="成功"></el-step>
        </el-steps>
        <div class="content" v-if="oneFormDiv">
            <el-form :model="oneForm" status-icon :rules="oneRules" ref="oneForm" class="form" size="medium">
                <el-form-item label="手机号码"  prop="mobile">
                    <el-input type="input" v-model="oneForm.mobile"></el-input>
                </el-form-item>
                <!--<el-form-item label="商户名称" prop="name">-->
                    <!--<el-input v-model="oneForm.name"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="邀请码" prop="inviteCode">
                    <el-input type="password" v-model="oneForm.inviteCode">
                        <!--<template slot="append">-->
                            <!--<el-button type="primary" :disabled="codeButton" @click="sendCode">{{codeButtonHtml}}</el-button>-->
                        <!--</template>-->
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="margin-top: 12px;"  @click="next">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content" v-if="twoFormDiv">
            <el-form :model="twoForm" status-icon :rules="twoRules" ref="twoForm" class="form" size="medium">
                <el-form-item label="顶级部门编号"  prop="code">
                    <el-input type="input" v-model="twoForm.code"></el-input>
                </el-form-item>
                <el-form-item label="顶级部门名称" prop="departmentName">
                    <el-input type="input" v-model="twoForm.departmentName"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="company">
                    <el-input type="input" v-model="twoForm.company"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="margin-top: 12px;"  @click="next">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content" v-if="threeFormDiv">
            <el-form :model="threeForm" status-icon :rules="threeRules" ref="threeForm" class="form" size="medium">
                <el-form-item label="员工编码"  prop="code">
                    <el-input type="code" v-model="threeForm.code"></el-input>
                </el-form-item>
                <el-form-item label="员工名称">
                    <el-input v-model="oneForm.name"></el-input>
                </el-form-item>
                <el-form-item label="员工生日">
                    <el-date-picker
                            v-model="threeForm.birthDate"
                            type="date"
                            value-format="timestamp"
                            placeholder="选择员工生日">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="入职日期">
                    <el-date-picker
                            v-model="threeForm.entryDate"
                            type="date"
                            value-format="timestamp"
                            placeholder="选择入职日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="员工性别">
                    <el-radio v-model="threeForm.gender" label="MALE" border size="medium">男</el-radio>
                    <el-radio v-model="threeForm.gender" label="FEMALE" border size="medium">女</el-radio>
                </el-form-item>
                <el-form-item label="初始积分"  prop="initPoint">
                    <el-input type="number"  v-model="threeForm.initPoint" ></el-input>
                </el-form-item>
                <el-form-item label="员工手机号">
                    <el-input type="input" v-model="oneForm.mobile" disabled></el-input>
                </el-form-item>
                <!-- <el-form-item label="员工邮箱" prop="email">
                    <el-input type="input" v-model="threeForm.email"></el-input>
                </el-form-item> -->
                <el-form-item label="登录密码" prop="password">
                    <el-input type="password" v-model="threeForm.password"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button style="margin-top: 12px;"  @click="next">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content" v-if="fourFormDiv">
            <el-alert
                    title="操作成功......."
                    type="success"
                    center
                    show-icon>{{jumpTimes}}秒后跳转登录界面
            </el-alert>
        </div>
          <el-button
            type="primary"
            plain
            @click.stop="toLogin"
            style="position: fixed;left: 5%;top: 5%;"
          >返回首页</el-button>
    </div>

</template>

<script>
    import { getInviteCode, invalidCode} from "@/api/salesCloud/inviteCode";
    import { addStuffAgent } from "@/api/salesCloud/stuff";
    import { addDepartmentAgent } from "@/api/salesCloud/department";
    import { validateEmail, validAccountAndPassword } from "@/util/validate";
    import { resolveUrlPath } from '@/util/util'
    const validateUserEmail = (rule, value, callback) => {
        if (!validateEmail(value)) {
            callback(new Error('请输入正确的邮箱'))
        } else {
            callback();
        }
    }
    const validPassword = (rule, value, callback) => {
        if (!validAccountAndPassword(value)) {
            callback(new Error('请输入6-16位的密码'))
        } else {
            callback();
        }
    }
    export default {
        data() {
            return {
                active: 0,
                oneForm: {},
                twoForm: {},
                threeForm: {},
                oneFormDiv: true,
                twoFormDiv: false,
                threeFormDiv: false,
                fourFormDiv: false,
                isShowPassword: true,
                jumpTimes: 3,
                oneRules: {
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { min: 11, max: 11, message: '请输入11位手机号码', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入商户名称', trigger: 'blur' }
                    ],
                    inviteCode: [
                        { required: true, message: '请输入短信邀请码', trigger: 'blur' }
                    ]

                },
                twoRules: {
                    departmentName: [
                        { required: true, message: '请输入部门名称', trigger: 'change' }
                    ],
                    code: [
                        { required: true, message: '请输入编号', trigger: 'change' },
                        { min: 1, max: 16 , message: '请输1-16位的编号', trigger: 'blur' }
                    ]
                },
                threeRules: {
                    code: [
                        { required: true, message: '请输入编号', trigger: 'blur' },
                        { min: 1, max: 16 , message: '请输1-16位的编号', trigger: 'blur' }
                    ],
                    // eMail: [
                    //     { required: false, message: '请输入邮箱', trigger: 'blur' },
                    //     { validator: validateUserEmail }
                    // ],
                    password: [
                        { required: true, message: '请输入登录密码', trigger: 'blur' },
                        { validator: validPassword }
                    ]
                },
                codeButton: false,
                codeButtonHtml: "获取验证码"
            };
        },
        created () {
        },
        methods: {
            toLogin(){
                this.$router.push({
                        path: resolveUrlPath("login", "登录")
                    })
            },
            next() {
                if(this.active == 0){
                    this.$refs["oneForm"].validate((valid) => {
                        if (valid) {
                            invalidCode(this.oneForm).then(response => {
                                let data = JSON.parse(response.data);
                                if(response.code == '200'){
                                    this.oneFormDiv = false
                                    this.active = 1
                                    this.twoFormDiv = true
                                    if(data.isHadAccount == 'YES'){
                                        this.isShowPassword = false
                                    }
                                }else{
                                    this.$message.error(response.message);
                                }
                            })
                        } else {
                            this.$message.error("请填写正确的表单数据");
                            return false;
                        }
                    });
                }else if(this.active == 1){
                    this.$refs["twoForm"].validate((valid) => {
                        if (valid) {
                            this.twoForm.name = this.twoForm.departmentName
                            addDepartmentAgent(this.twoForm).then(response => {
                                let data = JSON.parse(response.data);
                                if(response.code == '200'){
                                    this.twoForm.departPositionId = data.departPositionId
                                    this.twoForm.departId = data.departId
                                    this.twoFormDiv = false
                                    this.active = 2
                                    this.threeFormDiv = true
                                }else{
                                    this.$message.error(response.message);
                                }
                            })
                        } else {
                            this.$message.error("请填写正确的表单数据");
                            return false;
                        }
                    });
                }else if(this.active == 2){
                    this.$refs["threeForm"].validate((valid) => {
                        if (valid) {
                            this.threeForm.departId = this.twoForm.departId
                            this.threeForm.departPositionId = this.twoForm.departPositionId
                            this.threeForm.name = this.oneForm.name
                            this.threeForm.mobile = this.oneForm.mobile
                            addStuffAgent(this.threeForm).then(response => {
                                if(response.code == '200'){
                                    this.threeFormDiv = false
                                    this.active = 3
                                    this.fourFormDiv = true
                                    this.jumpTimer()
                                }else{
                                    this.$message.error(response.message);
                                }
                            })
                        } else {
                            this.$message.error("请填写正确的表单数据");
                            return false;
                        }
                    });
                }

            },
            
            // sendCode(){
            //     this.time=120;
            //     this.codeButton=true;
            //     this.timer();
            //     if(undefined == this.oneForm.mobile || undefined == this.oneForm.name){
            //         this.$message({
            //             message: '请填写手机号码和商户名称',
            //             type: 'warning'
            //         });
            //         return
            //     }
            //     getInviteCode(this.oneForm).then(response => {
            //         if(response.code == '200'){
            //             this.$message({
            //                 message: '邀请码已发送，请查收',
            //                 type: 'success'
            //             });
            //         }else{
            //             this.$message.error(response.message);
            //         }
            //     })
            // },
            timer(){
                if (this.time > 0) {
                    this.time--;
                    this.codeButtonHtml=this.time+"s,后重新获取验证码";
                    setTimeout(this.timer, 1000);
                } else{
                    this.time=0;
                    this.codeButtonHtml="获取验证码";
                    this.codeButton=false;
                }
            },
            jumpTimer(){
                if (this.jumpTimes != 0) {
                    this.jumpTimes --
                    setTimeout(this.jumpTimer, 1000);
                }else{
                    clearInterval(this.jumpTimer)
                    this.$router.push({
                        path: resolveUrlPath("login", "登录")
                    })
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .content {
        width: 40%;
        margin: 0 auto;
        padding: 20px 0;
        .menu {
            display: flex;
            justify-content: center;
        }
    }
    .form {
        border-bottom: 1px solid #f0f0f0;
        margin-bottom: 5px;
        padding: 20px;
        .el-form-item {
            margin-bottom: 5px;
        }
        &.bg {
            border-bottom: none;
            background: #fdfdfd;
        }
    }
</style>
